import SpotifyIcon from "../assets/Spotify_Icon_RGB_Green.png";
import YouTubeMusicIcon from "../assets/youtube-music-icon.png";
import AppleMusicIcon from "../assets/appleMusic.svg";
import YouTubeIcon from "../assets/youtube_social_icon_red.png";
import TidalIcon from "../assets/tidal_logo_black.png";

// export const SECTION_ONE_HEADING =
//     "Transfer Playlists Between Spotify, Apple Music & YouTube Music Instantly";

// export const SECTION_ONE_SUBHEADING =
//     "Stop wasting time recreating playlists. Instantly transfer your entire music library across Spotify, Apple Music, YouTube Music, and YouTube playlists — quick, accurate, and hassle-free.";

export const SECTION_TWO_HEADING =
    "Sync and Transfer Music Playlists Across Top Streaming Platforms";

// export const SECTION_TWO_SUBHEADING =
//     "Effortlessly move playlists between Spotify, Apple Music, YouTube Music, and more. 100% compatible with all playlist formats — keep every song and album intact during the transfer.";


export const SECTION_ONE_HEADING =
    "Transfer Playlists, Albums, and Favorites";
export const SECTION_ONE_SUBHEADING =
    "Stop rebuilding playlists. Transfer your complete music library between Spotify, Apple Music, YouTube Music, YouTube, and Tidal.";

// export const SECTION_TWO_HEADING =
//     "Transfer and Sync Playlists Seamlessly Between All Major Music Platforms";

export const SECTION_TWO_SUBHEADING =
    "Effortlessly transfer your playlists from Spotify, Apple Music, YouTube Music, YouTube, Tidal, and other platforms. Fully compatible with all playlist types, ensuring no track is left behind.";

export interface ISupportedApps {
    name: string;
    id: string;
    icon: string;
    link: string;
}

export const SUPPORTED_APPS: ISupportedApps[] = [
    {
        name: 'Spotify',
        id: 'tier-freelancer',
        icon: SpotifyIcon,
        link: '/spotify',
    },
    {
        name: 'Apple Music',
        id: 'tier-startup',
        icon: AppleMusicIcon,
        link: '/apple-music',
    },
    {
        name: 'YouTube Music',
        id: 'tier-enterprise',
        icon: YouTubeMusicIcon,
        link: '/youtube-music',
    },
    {
        name: 'YouTube',
        id: 'tier-enterprise',
        icon: YouTubeIcon,
        link: '/youtube',
    },
    {
        name: 'Tidal',
        id: 'tier-tidal',
        icon: TidalIcon,
        link: '/tidal',
    },
]